export const categoryWidgetsContext = 'category-widgets';
